import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import TagButton from '../../base/TagButton';
import Styles from './TagButtons.styles';
import translations from './translations'
import { getKey } from '../../../helpers';

const Headline = styled.a`
  ${Styles.headline};
`;
const Wrap = styled.div`
${Styles.wrap};
`;
/**
 * TagButtons component
 * @property {Array} items - button items
 * @returns {JSX}
 */
const TagButtons = ({ items, locale }) => {
  const { title } = getKey(translations, `${locale}`);
  
  return (
    <Wrap>
      <div className="row">
        <div className="col-12 offset-md-1">
          <Headline className="cbx-bold">{title}</Headline>
        </div>
        <div className="col-12 offset-md-1">
          {items.map(item => (
            <TagButton key={item.title} {...item} />
          ))}
        </div>
      </div>
    </Wrap>
  );
};

TagButtons.propTypes = {
  items: PropTypes.arrayOf(
    PropTypes.shape({
      titlebutton: PropTypes.string,
      link: PropTypes.string
    })
  ),
  locale: PropTypes.string
};

export default TagButtons;
